import React from "react";
import Linkedin from "../images/linkedin-logo.svg"


const LinkedinIcon = ({...rest }) => {
  return <Linkedin {...rest} />
}

export default LinkedinIcon